export enum APPOINTMENT_STEPS {
  CALENDAR,
  DETAILS,
  MOBILE_ASIDE,
  SUCCESS,
}
